import React, { useEffect, useState } from "react";
import ChatInput from "../components/ChatInput";
import MessageList from "../components/MessageList";
import { useConversation } from "../context/ConversationContext";
// import { useAPI } from "../context/APIContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
 
const ChatPage: React.FC = () => {
  const {
    currentConversation,
    selectedModel,
    selectedMode
    // sendMessage, // Not used directly - welcome buttons trigger ChatInput
    // loading,
    // setLoadingMessage,
    // setCurrentConversation,
    // setConversations,
    // setActiveConversationId,
    // fetchChatHistory,
  } = useConversation();
  // const api = useAPI();
  const location = useLocation();
  const navigate = useNavigate();
  const { conversationId } = useParams();
 
   // const companyName = process.env.REACT_APP_COMPANY_NAME || "RazorpayGPT"; // Removed unused variable
 
  // Shared conversation state
  const [sharedConversation, setSharedConversation] = useState<any>(null);
  const [isShareMode, setIsShareMode] = useState(false);
  const [sharedLoading, setSharedLoading] = useState(false);
  const [sharedError, setSharedError] = useState<string | null>(null);
 
  useEffect(() => {
    // If there is no active conversation and the URL has an id, redirect to "/"
    const match = location.pathname.match(/^\/c\/[\w-]+/);
    if (
      (!currentConversation || !currentConversation.messages?.length) &&
      match
    ) {
      navigate("/");
    }
  }, [currentConversation, location, navigate]);
 
  useEffect(() => {
    // Detect if we're on a /share/:conversationId route
    if (location.pathname.startsWith("/share/")) {
      setIsShareMode(true);
      setSharedLoading(true);
      setSharedError(null);
      // Fetch the shared conversation
     
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/share/${conversationId}`, { withCredentials: true })
        .then((res) => {
          setSharedConversation(res.data);
          setSharedLoading(false);
        })
        .catch((err) => {
          setSharedConversation(null);
          setSharedLoading(false);
          setSharedError("Failed to load shared conversation.");
        });
    } else {
      setIsShareMode(false);
    }
  }, [location, conversationId]);
 
  if (isShareMode) {
    if (sharedLoading) {
      return (
        <div className="flex items-center justify-center h-full">
          Loading shared conversation...
        </div>
      );
    }
    if (sharedError) {
      return (
        <div className="flex items-center justify-center h-full text-red-500">
          {sharedError}
        </div>
      );
    }
    if (!sharedConversation) {
      return (
        <div className="flex items-center justify-center h-full">
          No shared conversation found.
        </div>
      );
    }
    // Map backend messages to MessageList format
    const messages: any[] = [];
    (sharedConversation.messages || []).forEach((m: any) => {
      if (m.user_role) {
        messages.push({
          role: "user",
          content: m.user_role,
          timestamp: m.created_at,
          document_names: m.document_names || [],
        });
      }
      if (m.ai_role) {
        messages.push({
          role: "assistant",
          content: m.ai_role,
          timestamp: m.created_at,
          document_names: m.document_names || [],
        });
      }
    });
 
    return (
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto bg-gray-50 min-h-0">
          <div className="max-w-4xl mx-auto p-4 sm:p-8 mt-2">
            <MessageList messages={messages} />
          </div>
        </div>
      </div>
    );
  }
 
  // Check if this is a new conversation (no messages)
  const isNewConversation = !currentConversation || !currentConversation.messages || currentConversation.messages.length === 0;
 
  return (
    <div className="flex-1 flex flex-col h-full">
      {/* Header */}
      <div className="p-3 sm:p-4 border-b border-gray-200 bg-white flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
            <div className="min-w-0 flex-1">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 truncate">
                {(window as any).sanitizeTitle ? (window as any).sanitizeTitle(currentConversation?.title, 50, "New Chat") : (currentConversation?.title || "New Chat")}
              </h2>
              <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3 mt-1">
                <div className="inline-flex items-center rounded-full border px-2 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-green-100 text-green-700 border-green-200 text-xs">
                  {selectedModel || "GPT-4o"} Active
                </div>
                <span className="text-xs sm:text-sm text-gray-500 hidden sm:inline">Updated just now</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main content - takes remaining space */}
      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
          {/* Welcome message for new conversations */}
          {isNewConversation && (
            <div className="flex items-center justify-center min-h-[60vh]">
              <div className="text-center max-w-4xl mx-auto px-4">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6 sm:mb-8 shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-circle w-8 h-8 sm:w-10 sm:h-10 text-white" aria-hidden="true">
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                  </svg>
                </div>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">How can I help you today?</h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-8 sm:mb-12 max-w-3xl mx-auto">
                  {selectedMode === 'internal' 
                    ? 'Ask me anything about HR policies or Compliance process'
                    : 'Ask me anything'
                  }
                </p>

              </div>
            </div>
          )}

          {/* Messages */}
          {currentConversation?.messages && currentConversation.messages.length > 0 && (
            <MessageList messages={currentConversation.messages} />
          )}
        </div>
      </div>

      {/* Input area - fixed at bottom */}
      <div className="border-t border-gray-200 bg-white flex-shrink-0">
        <div className="w-full px-2 sm:px-4 md:px-6 lg:px-8 py-2 sm:py-4">
          <ChatInput />
          <p className="text-xs text-gray-500 text-center mt-2">RazorpayGPT can make mistakes. Consider checking important information.</p>
        </div>
      </div>
    </div>
  );
};

export default ChatPage;